<!--
~ Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
-->

<span class="text-content">
  <ng-content></ng-content>
</span>

@if (removable) {
  <button type="button" class="remove-btn"
    [attr.aria-label]="ariaLabel || 'Remove pill'"
    (click)="handleRemove($event)">
    <mat-icon inline>close</mat-icon>
  </button>
}
